// 가이드·루트 시드 데이터
// 참고용입니다. 지원 자격·과목·일정은 각 대학 최신 모집요항 원문으로 확인하세요.

export const guides = [
  {
    id: "eju-2026-syllabus",
    title: "2026 EJU 기초학력, 무엇이 바뀌나",
    summary:
      "2026년도 제1회부터 적용되는 이과·종합과목·수학 시라버스 개정을 JASSO 공식 기준으로 정리합니다.",
    category: "일정·변경",
    readTime: "7분",
    updatedAt: "2026-07",
    body: [
      {
        type: "p",
        text: "일본유학시험(EJU)의 기초학력 과목(이과·종합과목·수학) 출제 범위(시라버스)가 개정됩니다. 일본 고등학교 학습지도요령 개정에 맞춘 조치이며, JASSO가 개정판 시라버스를 공표했습니다. 적용 시점과 과목별 포인트를 먼저 파악한 뒤, 반드시 공식 원문으로 확인하세요.",
      },
      {
        type: "h3",
        text: "언제부터 적용되나",
      },
      {
        type: "ul",
        items: [
          "적용 시작: 2026년도 제1회 시험 출제부터 (통상 6월 실시 회차).",
          "대상 과목: 이과(물리·화학·생물), 종합과목, 수학.",
          "이번 기초학력 시라버스 개정 안내의 대상이 아닌 과목: 일본어(외국어로서의 일본어). 일본어 과목 범위는 별도 공지를 기준으로 확인하세요.",
          "배경: 고등학교 학습지도요령 개정(고시·시행)에 맞춰 기존 시라버스를 일부 개정.",
        ],
      },
      {
        type: "h3",
        text: "수학 — 코스1·코스2 범위 표현이 핵심",
      },
      {
        type: "p",
        text: "개정 시라버스에서 코스1·코스2 모두 현행 고등학교 학습지도요령에 준거한다고 명시됩니다. 이공·정보 등 높은 수학이 필요한 학부에서 흔히 요구하는 코스2는 범위 표기가 「수학Ⅰ·A·Ⅱ·B·Ⅲ·C」로 정리됩니다. 코스1은 「수학Ⅰ·A」 중심입니다. 지원 학부가 어느 코스를 지정하는지는 대학 모집요항으로 확인하세요.",
      },
      {
        type: "ul",
        items: [
          "코스1: 출제 범위는 수학Ⅰ·수학A. 현행 대비 추가 항목 예로 기대값(期待値)이 표에 제시됨.",
          "코스2: 수학Ⅰ·A·Ⅱ·B·Ⅲ·C. 현행 대비 추가 항목 예로 기대값·확률분포 등이 표에 제시됨.",
          "초·중학 범위는 이미 학습한 것으로 보고 출제 범위에 포함될 수 있음(공식 시라버스 문구).",
          "세부 단원·항목 번호는 JASSO 「수학 시라버스(2026년도 제1회부터)」 원문을 기준으로 할 것.",
        ],
      },
      {
        type: "h3",
        text: "종합과목 — 실질 범위보다 표기·구조 정비",
      },
      {
        type: "p",
        text: "JASSO는 종합과목 개정에 대해, 출제 내용의 실질적 변경은 없으면서 학습지도요령에 맞게 표현·항목을 다시 맞춘 것이라고 설명합니다. 정치·경제·사회·지리·역사의 소항목 표기·배치가 바뀌어도, ‘종합과목 전체 출제 범위가 크게 바뀌었다’고 단정하지 말고 개정판 시라버스와 대비표를 함께 보세요.",
      },
      {
        type: "ul",
        items: [
          "정치·경제·사회: 소항목을 중항목으로 올리는 등 표기 정리. 「현대의 국제사회」 항목 삭제 및 용어를 다른 중항목으로 재배치(내용 추가·삭제 없음이라는 공식 설명).",
          "지리: 「현대 세계의 제지역」 소항목 신설 등 표기 대응. 범위 추가·삭제 없음이라는 공식 설명.",
          "역사: 소항목 표기 변경 및 「냉전 후 세계」 신설 등. 기존에 정치·경제·사회에서 다루던 범위를 역사 쪽으로 옮긴 부분이 있어, 종합과목 전체로는 큰 범위 변동이 없다는 설명.",
        ],
      },
      {
        type: "h3",
        text: "이과 — 과목별 수정 폭이 다름",
      },
      {
        type: "ul",
        items: [
          "물리: 학습지도요령(물리기초·물리)에 맞춘 경미한 수정. 삭제·추가 항목 ‘없음’으로 대비표에 기재.",
          "화학: 표기·구성·항목 순서 조정. 대비표상 삭제 예: 열화학방정식. 추가 예: 용해도곱, 엔탈피(엔탈피 변화 표기 등). 세부 항번은 화학 시라버스 원문 확인.",
          "생물: 구성·순서 변경. 대비표상 추가 예: 「생태계와 인간 생활」. 물리와 같이 초·중학 범위는 기습으로 포함될 수 있음.",
          "이과에서 물리·화학·생물 중 어느 조합을 치를지는 지원 대학·학부 요강이 우선.",
        ],
      },
      {
        type: "h3",
        text: "수험생 체크리스트",
      },
      {
        type: "ul",
        items: [
          "내가 치를 EJU 회차가 2026년도 제1회 이후인지 확인한다.",
          "수학 코스1 vs 코스2를 요강에서 확인하고, 개정 시라버스의 해당 코스 항목을 대조한다.",
          "이과 선택 과목(물리/화학/생물)의 개정판 시라버스를 각각 연다.",
          "종합과목은 ‘범위가 통째로 바뀌었다’는 소문보다 JASSO 대비표(실질 변경 없음 설명)를 먼저 읽는다.",
          "대학 요강의 EJU 지정 회차·과목·출제 언어는 시라버스 개정과 별개로 매년 확인한다.",
          "커뮤니티의 대학별 원점수 컷오프를 개정 가이드의 삼지 않는다. 득점등화·회차·본고사 비중이 다르다.",
        ],
      },
      {
        type: "note",
        text: "1차 출처: JASSO 「日本留学試験－シラバス改訂について」 및 「2026年度第1回試験の出題から適用する基礎学力科目シラバスの公表」(개정 포인트·대비표·과목별 시라버스 링크). 사이트 요약은 참고용이며, 출제 항목의 최종 근거는 항상 JASSO 원문과 지망교 모집요항입니다. 공식 자료(/resources)의 EJU 시라버스 개정 항목에서도 같은 링크를 모았습니다.",
      },
    ],
  },
  {
    id: "reading-official-notices",
    title: "EJU·대사관·DNC 공고가 뜨면 어디를 보나",
    summary:
      "시즌마다 올라오는 공식 공고를 어디에 열어보고, 무엇을 체크한 뒤 요강·캘린더로 옮기는지 상시 절차로 정리합니다.",
    category: "일정·변경",
    readTime: "6분",
    updatedAt: "2026-07",
    body: [
      {
        type: "p",
        text: "입시 시즌이 오면 EJU(JASSO), 국비(주한일본대사관·Study in Japan), 공통테스트(DNC) 공고가 각각 다른 사이트에 올라옵니다. 커뮤니티 요약보다 공식 페이지의 ‘해당 연도’ 공고를 먼저 열고, 날짜·마감·대상은 원문 그대로 메모한 뒤 요강과 대조하세요. 이 글은 상시 절차이며 구체 시험일 숫자는 넣지 않습니다.",
      },
      {
        type: "h3",
        text: "먼저 열 곳 (기관별)",
      },
      {
        type: "ul",
        items: [
          "EJU: JASSO 일본유학시험 페이지 → 해당 연도 실시 요항·출원 안내·시라버스(개정 시)",
          "국비(MEXT) 학부: 주한일본대사관 국비 안내 → 해당 연도 모집 공고 PDF/HTML",
          "국비 제도 개요: Study in Japan 학부·Embassy Recommendation 안내 (연도 공고와 함께)",
          "공통테스트·일반선발: DNC 대학입학공통테스트 → 해당 연도 실시 요항·Web 출원",
          "대학 전형: 지망교 입시·유학생 페이지의 해당 연도 모집요항 PDF",
        ],
      },
      {
        type: "h3",
        text: "공고에서 옮길 체크 항목",
      },
      {
        type: "ul",
        items: [
          "대상 연도·회차(제1회/제2회 등)와 ‘적용 시작’ 문구",
          "출원 기간·시험일·성적 발표(있다면) — 사이트 캘린더는 프레임만, 숫자는 공고가 최종",
          "자격·국적·재외교육 과정 제한",
          "수수료·지불 방법·출원 시스템 URL",
          "첨부 서류 목록과 직송·온라인 제출 구분",
          "문의처(기관 공식만). 학원·카페 해석은 보조",
        ],
      },
      {
        type: "h3",
        text: "연 단위 루틴",
      },
      {
        type: "ul",
        items: [
          "시즌 일정(/calendar)에서 어느 블록(EJU·MEXT·공통·출원)인지 표시",
          "무료 시즌 알림(/alerts) 또는 시즌패스(/pass)로 리마인더만 받기",
          "관심 대학 요강 PDF를 비교표(/compare)·체크리스트(/checklist)에 반영",
          "공식 자료(/resources) 북마크를 분기마다 한 번 열어 링크가 살아 있는지 확인",
        ],
      },
      {
        type: "h3",
        text: "하지 말 것",
      },
      {
        type: "ul",
        items: [
          "전년도 공고 PDF를 그대로 올해 일정으로 쓰는 것",
          "SNS의 ‘○월 ○일 확정’ 스크린샷만 믿고 출원·응시하는 것",
          "합격선·커트 루머를 공고 요약에 섞는 것",
        ],
      },
      {
        type: "note",
        text: "미라이쥬쿠 요약·캘린더는 참고용입니다. 시험일·마감·자격의 최종 근거는 항상 JASSO·대사관·DNC·대학의 해당 연도 공고·모집요항 원문입니다.",
      },
    ],
  },
  {
    id: "eju-vs-general",
    title: "EJU와 일반입시, 무엇이 다른가",
    summary: "유학생 전형과 일본인·일반 루트의 시험·일정·경쟁 구조를 한 장으로 정리합니다.",
    category: "루트 이해",
    readTime: "8분",
    updatedAt: "2026-07",
    body: [
      {
        type: "p",
        text: "일본 대학 진학을 준비하는 한국인 수험생 여러분을 위한 미라이쥬쿠 입시 가이드입니다. 일본 학부 입시 루트는 크게 외국인 수험생을 대상으로 하는 '유학생 특별전형(사비 외국인 유학생 전형)'과 일본 현지 수험생들과 동일한 조건에서 경쟁하는 '일반선발(一般選抜)' 두 가지로 나뉩니다. 두 루트는 평가 요소부터 경쟁 대상까지 명확한 차이가 있으므로 각 전형의 특징을 정확하게 파악해야 합니다.",
      },
      {
        type: "h3",
        text: "JASSO EJU 기반 유학생 특별전형의 특징",
      },
      {
        type: "p",
        text: "대부분의 한국인 유학생이 선택하는 주된 경로입니다. 독립행정법인 일본학생지원기구(JASSO)가 주관하는 일본유학시험(EJU) 성적을 바탕으로 선발이 진행됩니다. EJU는 연 2회(6월 셋째 일요일, 11월 셋째 일요일) 실시되며 성적은 시험 후 약 1~1.5개월 후에 통지됩니다. 국립대의 98%, 공립대의 61%, 사립대의 52%가 이 시험 성적을 의무화하거나 요구하고 있습니다.",
      },
      {
        type: "ul",
        items: [
          "선발 방식: 정원 외(별도枠)로 선발하여 일본인 수험생과 직접 경쟁하지 않습니다.",
          "수험 과목: 지원 학과별로 지정 과목을 선택하여 응시합니다. 일본어(일본어 출제)를 비롯하여 종합과목(정치·경제·사회·지리·역사 등), 수학(코스 1은 문과용, 코스 2는 이과용), 이과(물리·화학·생물 중 2과목 선택)가 있습니다. 일본어 과목을 제외한 과목은 일본어 또는 영어 중 출제 언어를 선택할 수 있습니다.",
          "주요 평가 요소: EJU 성적, JLPT(N1/N2) 또는 EJU 일본어 점수, 영어 성적(TOEFL, TOEIC, IELTS 등), 서류(자기소개서, 추천서, 성적증명서 등) 및 대학별 소논문, 필기시험, 면접 등을 종합합니다.",
          "주요 이점: 일본인 대상 일반 입시에 비해 과목 수와 난이도 부담이 상대적으로 낮으며, 성적 우수자에게는 유학생 학습 장려금(장학금) 지급 제도의 기회가 주어집니다.",
        ],
      },
      {
        type: "h3",
        text: "일반선발(一般選抜) 및 본시험 루트의 특징",
      },
      {
        type: "p",
        text: "일본 국적 수험생을 주 대상으로 하는 전형이지만, 일부 대학 및 학과에서는 외국인 수험생의 지원도 허용합니다. 일본 고등학교에 재학 중인 외국인이나 일본어 및 교과 학력이 매우 우수한 소수의 수험생이 도전하는 경로입니다.",
      },
      {
        type: "ul",
        items: [
          "선발 방식: 정원 내 선발로 진행되며, 일본 현지 수험생과 동일한 조건에서 정면으로 경쟁해야 합니다.",
          "주요 평가 요소: 국·공립대 중심의 대학입시센터시험(共通テスト) 점수와 대학별로 실시하는 2차 시험(본시험 필기·면접·실기 등)을 합산합니다. 일부 대학에서는 고교 성적(학생부)이나 추천서를 요구하기도 합니다.",
          "주요 특징: 일본 고교 교육과정을 기반으로 출제되므로 난이도가 매우 높고 극단적인 수준의 일본어 능력이 전제되어야 합니다. 외국인 유학생에게는 지극히 불리할 수 있으나, 유학생 특별전형을 실시하지 않고 일반선발만 허용하는 특정 학과(일부 의학부, 법학부 등)를 지원할 때는 이 루트를 사용해야 합니다.",
        ],
      },
      {
        type: "h3",
        text: "지원 전략 및 수험생 체크리스트",
      },
      {
        type: "p",
        text: "의대, 약대, 법대 등 일부 전문 학과의 경우 유학생 특별전형을 아예 실시하지 않거나 오직 일반선발로만 학생을 모집하는 경우가 존재하므로 학과별 모집 제한을 반드시 확인해야 합니다. 유학생 특별전형과 일반선발 간의 중복 지원 가능 여부 역시 대학마다 개별적으로 다르게 규정하고 있습니다.",
      },
      {
        type: "note",
        text: "주의: 인터넷에 떠도는 대략적인 점수나 합격선 수치는 매년 변동되므로 결코 단정적인 기준으로 삼아서는 안 됩니다. 반드시 지망하는 대학 홈페이지의 '모집요항(募集要項)' 이나 '입시정보(入試情報)' 페이지를 접속하여 출제 언어, EJU 지정회차, 영어성적 인정 기준, 비자 및 국적에 따른 출원자격, 수수료, 시험 일정 등 원문 내용을 최우선으로 직접 확인하고 검증하십시오.",
      },
    ],
  },
  {
    id: "ao-sogo",
    title: "종합형·학교추천, EJU·일반과 어떻게 다른가",
    summary:
      "종합형선발·학교추천형선발을 EJU 유학생 특별전형·일반선발과 나란히 놓고, 요강에서 확인할 항목만 정리합니다.",
    category: "루트 이해",
    readTime: "8분",
    updatedAt: "2026-07",
    body: [
      {
        type: "p",
        text: "일본 학부 진학을 준비하는 한국인 수험생이 선택할 수 있는 입시 루트는 점차 다변화되고 있습니다. 전통적인 EJU 유학생 특별전형 외에도 종합형 선발, 학교추천형 선발, 그리고 일본인 수험생과 경쟁하는 일반선발의 구조적 차이를 이해해야 본인에게 유리한 출원 전략을 수립할 수 있습니다.",
      },
      {
        type: "h3",
        text: "입시를 구성하는 세 가지 주요 루트",
      },
      {
        type: "ul",
        items: [
          "EJU 유학생 특별전형: 일본유학시험(EJU) 성적과 대학별 본고사(소논문, 면접 등)를 중심으로 평가하는 유학생 대상 전형입니다.",
          "종합형·학교추천형 선발: 지원자의 적성, 학업 의욕, 고교 재학 중 성과를 서류와 면접, 프레젠테이션 등으로 종합 평가하는 전형입니다.",
          "일반선발: 일본인 수험생과 동일한 조건에서 대학입학공통테스트 및 대학별 본고사를 치르는 전형으로, 고도의 일본어 및 교과 지식이 요구됩니다.",
        ],
      },
      {
        type: "h3",
        text: "종합형 선발과 학교추천형 선발의 차이점",
      },
      {
        type: "p",
        text: "구 AO입시에 해당하는 종합형 선발은 대학의 인재상에 부합하는지 스스로 증명하는 자기추천 방식입니다. 반면 학교추천형 선발은 출신 고등학교 교장의 추천이 필수적이며, 재학 기간 내의 평정평균과 성실성이 주요 평가지표가 됩니다.",
      },
      {
        type: "h3",
        text: "모집요강에서 반드시 체크해야 할 항목",
      },
      {
        type: "ul",
        items: [
          "출원 자격 확인: 외국인 국적자 및 해외 고교 졸업자의 지원 가능 여부와 비자 취득 요건을 검토합니다.",
          "EJU 지정 회차 및 제출 과목: 전형 과정에서 EJU 성적을 반영하는지, 반영한다면 지정된 시험 회차와 필수 과목을 확인합니다.",
          "제출 서류 및 영어 성적: 최종학력 증명서, 추천서 서식과 함께 공인영어성적의 원본 제출 요구 여부 및 유효기간을 체크합니다.",
          "시험 방식 및 장소: 면접과 소논문 등의 본고사가 온라인으로 진행되는지, 아니면 일본 현지 대학 캠퍼스에 방문하여 응시해야 하는지 확인합니다.",
        ],
      },
      {
        type: "h3",
        text: "수험생이 헷갈리기 쉬운 점",
      },
      {
        type: "ul",
        items: [
          "종합형이나 추천형 전형이 서류와 면접만으로 합격자를 선발한다는 오해가 있으나, 많은 대학이 기초 학력 테스트나 강도 높은 소논문을 병행합니다.",
          "일부 종합형·학교추천형 요강은 일본 국내 거주자만을 대상으로 하거나 유학생 특별 비자 발급을 지원하지 않는 경우가 있으므로 국적 및 거주지 제한 요건을 세밀히 읽어야 합니다.",
        ],
      },
      {
        type: "h3",
        text: "다음에 할 일",
      },
      {
        type: "ul",
        items: [
          "지망 대학 공식 홈페이지에 접속하여 최신 모집요강 및 출원 서류 양식을 다운로드합니다.",
          "루트 파인더(/finder)로 본인 조건에 맞는 전형을 탐색합니다.",
          "요강 체크리스트(/checklist)로 전형별 서류·일정을 정리합니다.",
          "EJU와 일반 비교는 /guides/eju-vs-general 가이드를 함께 보세요.",
        ],
      },
      {
        type: "note",
        text: "본 가이드는 참고용입니다. 전형 일정·평가 기준·외국인 지원 가능 여부는 각 대학 해당 연도 모집요항 원문으로 최종 확인하세요. 합격선은 단정하지 않습니다.",
      },
    ],
  },
  {
    id: "mext-scholarship",
    title: "국비유학(MEXT) 루트 개요",
    summary:
      "대사관 추천과 대학 추천의 구조·타임라인을 나누고, EJU·사비 전형과의 병행을 현실적으로 짚습니다.",
    category: "국비",
    readTime: "10분",
    updatedAt: "2026-07",
    body: [
      {
        type: "p",
        text: "문부과학성(MEXT) 국비 학부 유학생은 크게 대사관 추천(Embassy Recommendation)과 대학 추천(University Recommendation)으로 나뉩니다. 심사 주체·시험·도일 시기·장학금 기간이 다르므로, 먼저 어느 쪽 공고를 볼지 정한 뒤 일정을 역산하세요.",
      },
      {
        type: "h3",
        text: "한눈에 보는 차이",
      },
      {
        type: "ul",
        items: [
          "대사관 추천: 재외공관이 1차 심사. 지정 필기·면접이 있는 경우가 많음. 일본어 예비교육이 붙을 수 있음. 배치 희망 대학을 복수로 적을 수 있는 구조가 일반적(해당 연도 공고 확인).",
          "대학 추천: 일본 대학이 1차 심사 후 문부과학성에 추천. 서류·면접 중심인 경우가 많고, 추천 대학에 묶이는 성격이 강함. 어학·서류 요건은 대학마다 다름.",
          "공통: 세부 연령·학력·성적·서류·월액은 연도·공고마다 바뀌므로 Study in Japan·주한일본대사관·지망교 원문이 최종.",
        ],
      },
      {
        type: "h3",
        text: "대사관 추천 — 타임라인 프레임",
      },
      {
        type: "p",
        text: "한국에서는 주한일본대사관 공고가 출발점입니다. 아래는 ‘대략적인 순서’이며, 월 단위는 해당 연도 공고로 덮어쓰세요.",
      },
      {
        type: "ul",
        items: [
          "공고 확인 → 서류 준비·제출",
          "필기(지정 과목) → 면접 등 1차 심사",
          "1차 이후 대학 측 전형·배치 희망 절차",
          "문부과학성 최종 → 도일·예비교육 또는 입학",
          "준비물 예: 지원서, 성적·졸업(예정) 증명, 건강진단, 여권 사본 등 — 공고 목록이 우선",
        ],
      },
      {
        type: "h3",
        text: "대학 추천 — 타임라인 프레임",
      },
      {
        type: "ul",
        items: [
          "지망 대학이 해당 연도에 학부 국비 추천을 모집하는지 국제교류·유학생 페이지에서 확인",
          "대학별 마감·서류·어학(예: JLPT·영어) 요건 수집",
          "대학 심사 → (통과 시) 문부과학성 절차 — 일정은 대학마다 완전히 다름",
          "한 대학에 고정되는 경우가 많으므로, 사비 EJU/일반 병행 여부를 같이 설계",
        ],
      },
      {
        type: "h3",
        text: "EJU·사비 전형과의 관계",
      },
      {
        type: "ul",
        items: [
          "대사관 추천 필기는 EJU와 별개인 경우가 많음(공고의 시험 과목 확인).",
          "국비 결과만 기다리면 일정이 비기 쉬움. 사비 유학생 전형·일반선발 병행 플랜을 권장.",
          "국비 배치 전공과 사비로 지원할 학부가 다를 수 있음 — 목표를 문서로 나눠 적기.",
        ],
      },
      {
        type: "note",
        text: "공식 창구: 주한일본대사관 국비 안내·최신 공고, Study in Japan의 MEXT 학부(Embassy Recommendation) 안내, 지망 대학 국제입시 페이지. 연령·성적 환산·월액 등 숫자는 가이드에 단정하지 말고 공고 원문을 보세요.",
      },
    ],
  },
  {
    id: "science-medicine-path",
    title: "이공·정보와 의치약, 루트가 갈리는 지점",
    summary: "과목·전형·경쟁 구조가 어디서 갈리는지, 요강에서 무엇을 볼지.",
    category: "계열",
    readTime: "9분",
    updatedAt: "2026-07",
    body: [
      {
        type: "p",
        text: "이공·정보와 의치약(의학·치학·약학)은 ‘일본 학부’라는 말로는 묶여도, 전형 설계·과목·정원·경쟁의 결이 다릅니다. 한국인 수험생이 먼저 갈라야 할 것은 희망 계열이 EJU 유학생 특별전형을 쓰는지, 아니면 일본인 일반선발(共通テスト·본고사)에 가까운지입니다.",
      },
      {
        type: "h3",
        text: "이공·정보에서 자주 보는 구조",
      },
      {
        type: "ul",
        items: [
          "유학생 특별전형이 비교적 넓게 열려 있고, EJU(일본어·수학 코스2·이과 등)를 축으로 하는 대학이 많음 — 조합은 학부 요강이 최종.",
          "대학별 2차로 소논문·면접·전공 기초 필기가 붙는 경우가 있어, EJU만으로 끝나지 않는 학부가 있음.",
          "영어 외부시험(TOEFL·IELTS·TOEIC 등) 요구·직송 여부는 요강 표로 정리 (관련: 영어 성적 가이드).",
          "2026 EJU 기초학력 시라버스 변경(수학·이과·종합)이 있으면 이공 지원자는 개정판을 먼저 확인.",
        ],
      },
      {
        type: "h3",
        text: "의치약에서 루트가 갈리는 이유",
      },
      {
        type: "ul",
        items: [
          "국립·일부 공립은 외국인 특별전형이 없거나 매우 좁고, 일반선발(공통테스트·본고사)이 중심인 경우가 있음.",
          "사립은 EJU 활용 유학생 전형이 있어도 서류·소논문·면접·학력시험이 겹치는 다단계가 흔함.",
          "EJU를 쓸 때도 화학·생물 비중이 큰 조합이 많고, 일본어 요구가 높게 잡히는 학부가 있음.",
          "면허·국가시험·임상 관련 안내는 학부 안내문을 요강과 별도로 확인.",
        ],
      },
      {
        type: "h3",
        text: "요강·공식에서 같이 볼 것",
      },
      {
        type: "ul",
        items: [
          "외국인 유학생 특별전형 유무 (없으면 일반선발·다른 루트인지)",
          "EJU 지정 과목·수학 코스·인정 회차·출제 언어",
          "JLPT 대체 가능 여부, 영어 외부시험 최저·유효기간·제출 방식",
          "2차(필기·소논문·면접) 유무와 일정, 검정료·필착",
          "공식 입시 페이지: JASSO EJU, DNC 공통테스트(일반선발 시), 대학 admissions",
          "도구: 요강 체크리스트·루트 파인더로 계열별 예시 링크 확인",
        ],
      },
      {
        type: "note",
        text: "편차치·합격률·‘이 점수면 가능’ 류 숫자는 출처·연도가 섞이기 쉽습니다. 지원 직전 판단은 해당 연도 대학 모집요항 원문과 JASSO·대학 공식 안내만 기준으로 하세요.",
      },
    ],
  },
  {
    id: "mext-to-medicine",
    title: "국비 이공에서 일반입시 의대로",
    summary:
      "국비(이공) 경로와 의대 일반선발을 병행·전환할 때 확인할 의사결정 프레임입니다. 합격 보장이 아닙니다.",
    category: "계열",
    readTime: "8분",
    updatedAt: "2026-07",
    body: [
      {
        type: "p",
        text: "국비로 이공에 가까운 배치·전공을 밟다가, 나중에 의·치·약 계열을 일반선발(共通テスト·본고사)으로 다시 도전하는 경우는 ‘경로 전환’입니다. 제도가 자동으로 이어주지 않으며, 자격·과목·일정을 처음부터 다시 맞춰야 합니다. 아래는 결정용 체크 프레임이며 개인 합격을 보장하지 않습니다.",
      },
      {
        type: "h3",
        text: "먼저 분리해 적을 것",
      },
      {
        type: "ul",
        items: [
          "국비: 어느 추천(대사관/대학)인지, 배치·전공 제약, 재지원·전과의 가능 여부(공고·대학 규정)",
          "의계: 목표 학부가 유학생 특별전형을 쓰는지, 일반선발만 있는지",
          "시간축: 국비 선발·예비교육·재학 일정과 공통테스트·본고사 시즌이 겹치는지",
          "리스크: 국비 조건(전공·재적)과 사비/일반 재응시가 충돌하지 않는지 — 담당 창구에 확인",
        ],
      },
      {
        type: "h3",
        text: "일반입시 의계로 갈 때 현실 체크",
      },
      {
        type: "ul",
        items: [
          "공통테스트·본고사 과목 설계가 EJU 이공 준비와 다름 (DNC·대학 요강)",
          "출원자격(학력·일본어·재류)이 유학생 특별전형과 다를 수 있음",
          "일본 고교 과정에 가까운 준비가 필요해지면 비용·기간을 재추정",
          "‘국비를 했으니 의대가 유리’는 성립하지 않음 — 전형이 바뀌면 평가축이 바뀜",
        ],
      },
      {
        type: "h3",
        text: "병행이 나을 때 / 전환이 나을 때 (질문)",
      },
      {
        type: "ul",
        items: [
          "지금 목표 학부에 유학생 특별전형이 열려 있는가?",
          "국비 결과 대기 동안 사비 EJU·일반 일정을 비워 두고 있는가?",
          "의계가 일반선발뿐이면, 공통테스트 준비를 별 트랙으로 둘 여력이 있는가?",
          "서류·비자·재적 상태를 바꾸기 전에 공식 안내·담당자에게 확인했는가?",
        ],
      },
      {
        type: "note",
        text: "관련: 국비 개요, 이공·의치약 분기, EJU vs 일반입시, 요강 체크리스트. 최종은 대사관·대학·DNC 원문입니다.",
      },
    ],
  },
  {
    id: "yokoan-howto",
    title: "요강을 읽는 법 (募集要項)",
    summary: "원문 PDF에서 지원 자격·시험 과목·제출 서류를 빠르게 찾는 체크포인트.",
    category: "요강",
    readTime: "7분",
    updatedAt: "2026-07",
    body: [
      {
        type: "p",
        text: "일본 대학 입시에서 최종 기준은 대학이 해마다 내는 학생모집요항(学生募集要項)입니다. 요약 글·유학원 설명은 입구일 뿐이고, 자격·과목·일정·서류는 PDF 원문으로 확정하세요.",
      },
      {
        type: "h3",
        text: "먼저 찾는 위치",
      },
      {
        type: "ul",
        items: [
          "대학 공식 사이트 → 入試情報 / 外国人留学生 / 학부·전형별 안내",
          "파일명·표지에 연도(令和○ / 20XX)가 있는지 확인하고 전년도 PDF와 섞지 않기",
          "‘유학생 특별’과 ‘일반선발’ PDF가 분리된 경우가 많으니 지원 전형 파일을 열어두기",
        ],
      },
      {
        type: "h3",
        text: "자격·언어·시험 체크",
      },
      {
        type: "ul",
        items: [
          "出願資格: 12년 교육과정, 연령, 국적, 재류자격(유학) 관련 문구",
          "일본어: EJU 일본어 점수 또는 JLPT 급수 지정",
          "EJU: 과목·수학 코스·이과 조합·인정 회차(6월/11월)·출제 언어(일본어/영어)",
          "영어: TOEFL/IELTS/TOEIC 등 필수 여부, 최저 기준, 유효기간",
          "대학별 시험: 소논문·면접·학력시험 유무와 일정",
        ],
      },
      {
        type: "h3",
        text: "일정·비용·서류",
      },
      {
        type: "ul",
        items: [
          "원서 접수 기간, 시험일, 합격 발표, 입학 수속 마감",
          "검정료(検定料)와 납부 방법",
          "성적증명·졸업증명·번역·공증·사진·추천서 등 제출 형식",
          "합격 후 비자·입학금 관련 안내가 요강 밖 별도 페이지에 있는지도 확인",
        ],
      },
      {
        type: "note",
        text: "같은 대학이라도 학부·연도마다 규정이 바뀝니다. 스크린샷·후기보다 해당 연도 모집요항 원문 한 장이 우선입니다.",
      },
    ],
  },
  {
    id: "english-in-yokoan",
    title: "영어 성적, 요강에서 찾는 법",
    summary:
      "TOEFL·IELTS·TOEIC 등 외부시험을 요강 표에서 어떻게 읽고, 제출·유효기간을 확인할지 정리합니다.",
    category: "요강",
    readTime: "6분",
    updatedAt: "2026-07",
    body: [
      {
        type: "p",
        text: "많은 유학생·일반 전형이 EJU와 별도로 영어 외부시험 성적을 요구합니다. ‘대략 ○○점’ 커뮤니티 수치보다, 지망 대학 해당 연도 모집요항의 영어 항목이 기준입니다.",
      },
      {
        type: "h3",
        text: "요강에서 찾을 위치",
      },
      {
        type: "ul",
        items: [
          "出願資格·选考方法·提出書類 근처의 영어·외국어 성적 표",
          "인정 시험 종류(TOEFL iBT, IELTS, TOEIC, Duolingo 등)와 제외되는 종류",
          "최저 기준이 ‘필수’인지 ‘제출만’인지, 배점에 포함되는지",
          "성적 유효기간(시험일 기준 몇 년/몇 개월)",
          "제출 방식: 원서 동봉 사본, 기관 직송(official score report), 온라인 코드",
        ],
      },
      {
        type: "h3",
        text: "자주 하는 실수",
      },
      {
        type: "ul",
        items: [
          "전년도 요강의 점수표를 그대로 쓰는 것",
          "시험 종류는 맞지만 직송 마감을 놓치는 것",
          "홈 에디션·바르셀로나 등 특정 응시 형태를 요강이 인정하지 않는 경우",
          "EJU 영어 과목과 외부시험을 혼동하는 것(대학마다 다름)",
        ],
      },
      {
        type: "h3",
        text: "체크 순서",
      },
      {
        type: "ul",
        items: [
          "관심 대학 2~3곳의 영어 행만 표로 옮겨 적는다",
          "가장 까다로운 조건(종류·점수·직송)에 맞춰 시험 일정을 잡는다",
          "요강 체크리스트의 ‘영어 외부시험’ 항목을 켠다",
          "지원 직전 PDF로 한 번 더 대조한다",
        ],
      },
      {
        type: "note",
        text: "대학·학부·연도마다 기준이 다릅니다. 합격선 루머나 ‘국립은 무조건 ○○’ 단정은 쓰지 마세요. 최종은 모집요항 원문입니다.",
      },
    ],
  },
  {
    id: "prearrival-scholarship",
    title: "도일 전 입학·학습장려비 예약",
    summary:
      "EJU를 이용한 渡日前入学許可와, 사전입학 연계 학습장려비 예약의 개념을 JASSO 기준으로 정리합니다.",
    category: "제도",
    readTime: "8분",
    updatedAt: "2026-07",
    body: [
      {
        type: "p",
        text: "해외에서 전형·합격을 마치고 입학 허가까지 받는 흐름을 ‘도일 전 입학허가(渡日前入学許可)’라고 부릅니다. JASSO는 EJU 성적을 활용해 이를 실시하는 학교 목록을 공개합니다. 이와 별개로, 사전입학을 전제로 한 문부과학성 학습장려비(사비) 예약 제도가 있습니다. 둘 다 ‘자동 수혜’가 아니며 학교·연도 조건이 따릅니다.",
      },
      {
        type: "h3",
        text: "渡日前入学許可 (EJU 이용)",
      },
      {
        type: "ul",
        items: [
          "정의(요지): 지원자가 해외에 있으면서 일본 대학 등의 선발에 응시하고, 입학 허가를 받을 수 있게 하는 제도.",
          "EJU 이용형: EJU 성적을 활용해 국외에서 출원·선발하고, 선발을 위해 일본에 오지 않고 합격을 판단하는 형태.",
          "JASSO가 공개하는 ‘EJU 이용 渡日前入学許可校’ 목록을 출발점으로 쓰되, 목록은 수시 갱신된다.",
          "과목·출제언어·서류·점수는 목록이 아니라 각 학교 입시요강이 최종.",
          "국내 EJU 시험장 응시자만 받는 전형 등은 정의상 ‘渡日前’에 해당하지 않을 수 있으니 요강 문구를 읽는다.",
        ],
      },
      {
        type: "h3",
        text: "사전입학 연계 학습장려비 예약",
      },
      {
        type: "ul",
        items: [
          "사비 유학생 대상 문부과학성 학습장려비의 ‘예약’ 유형 중, 사전입학(渡日前)과 연계된 프로그램이 있다.",
          "월액·지급 기간은 연도에 따라 달라질 수 있다(공식 안내에 기재된 금액·기간을 확인).",
          "신청은 학생이 JASSO에 직접 넣는 형태가 아니라, 입학(예정) 학교를 통해 절차를 밟는 경우가 일반적이다.",
          "정규 학생 요건, 대상 학교·코스 목록, 봄/가을 입학별 안내를 공식 페이지에서 확인한다.",
          "EJU 성적우수자 예약 등 다른 예약 제도와 이름이 비슷하니, 공식 페이지 제목·대상이 같은지 구분해 읽는다.",
        ],
      },
      {
        type: "h3",
        text: "수험생 액션",
      },
      {
        type: "ul",
        items: [
          "JASSO 渡日前 목록에서 관심 학교 후보를 추린다",
          "각 학교 요강에서 ‘해외 출원·화상 면접·EJU 지정’을 확인한다",
          "학습장려비 예약이 필요하면 입학 예정교 국제·유학생 창구에 절차를 묻는다",
          "사비 EJU 전형과 일정·과목이 맞는지 체크리스트로 정리한다",
        ],
      },
      {
        type: "note",
        text: "1차 출처: JASSO 「EJU를 이용한 渡日前入学許可校」 목록 및 학습장려비(사전입학 예약) 공식 안내. 금액·대상교·기간은 변경될 수 있으니 지원 직전에 원문을 다시 여세요.",
      },
    ],
  },
  {
    id: "example-national-stem",
    title: "예시: 국립 이공 입시 페이지 읽기",
    summary:
      "홋카이도대·오사카대 등 국립 입시 톱페이지에서 유학생·학부 요강 PDF까지 가는 길을 연습합니다.",
    category: "대학 예시",
    readTime: "6분",
    updatedAt: "2026-07",
    body: [
      {
        type: "p",
        text: "이 글은 특정 대학 합격을 안내하지 않습니다. 국립대 이공 계열에서 ‘입시 톱 → 외국인 유학생·학부 → 해당 연도 PDF’로 내려가는 읽기 연습용 예시입니다. 숫자·정원·합격선은 적지 않습니다.",
      },
      {
        type: "h3",
        text: "시작 URL (공식)",
      },
      {
        type: "ul",
        items: [
          "홋카이도대학 입시: https://www.hokudai.ac.jp/admission/",
          "오사카대학 입시: https://www.osaka-u.ac.jp/ja/admissions",
          "JASSO EJU(과목·회차 배경): https://www.jasso.go.jp/ryugaku/eju/index.html",
        ],
      },
      {
        type: "h3",
        text: "페이지에서 찾을 순서",
      },
      {
        type: "ul",
        items: [
          "『外国人留学生』『私費外国人』『学部』 등 유학생·학부 메뉴를 연다",
          "연도(令和○ / 20XX)가 적힌 모집요항 PDF인지 확인 — 전년도 파일과 섞지 않기",
          "이공·정보 학부·학과명을 지망과 대조",
          "EJU 과목·수학 코스·지정회·출제언어·영어 외부시험 표를 노트에 옮긴다",
          "2차(면접·소논문) 유무와 해외출원·필착을 체크리스트에 옮긴다",
        ],
      },
      {
        type: "h3",
        text: "다음에 할 일",
      },
      {
        type: "ul",
        items: [
          "같은 방식으로 관심 국립 2~3곳 표를 만든다 (비교 도구 활용)",
          "2026 EJU 시라버스 개정과 수학 코스2 범위를 대조",
          "루트 파인더 ‘EJU → 이공’ 예시 링크로 후보를 더한다",
        ],
      },
      {
        type: "note",
        text: "학부·연도마다 규정이 바뀝니다. 최종은 해당 연도 모집요항 PDF입니다.",
      },
    ],
  },
  {
    id: "example-private-hum",
    title: "예시: 사립 문과 입시 페이지 읽기",
    summary:
      "와세다·게이오·조치 등 사립 입시 사이트에서 전형명과 요강 PDF를 맞추는 연습입니다.",
    category: "대학 예시",
    readTime: "6분",
    updatedAt: "2026-07",
    body: [
      {
        type: "p",
        text: "사립은 학부·전형(유학생/AO/일반)마다 PDF가 쪼개져 있는 경우가 많습니다. ‘입학 센터 톱’과 ‘학부 유학생 요강’을 혼동하지 않는 것이 목표입니다.",
      },
      {
        type: "h3",
        text: "시작 URL (공식)",
      },
      {
        type: "ul",
        items: [
          "와세다 입학: https://www.waseda.jp/inst/admission/",
          "게이오 입학: https://www.keio.ac.jp/ja/admissions/",
          "조치 입시: https://adm.sophia.ac.jp/",
        ],
      },
      {
        type: "h3",
        text: "읽을 때 포인트",
      },
      {
        type: "ul",
        items: [
          "지원하려는 전형명(유학생·영어 프로그램·일반 등)과 PDF 제목이 일치하는지",
          "EJU·일본어·영어 외부시험·소논문·면접 중 무엇이 필수인지 표로 정리",
          "영어 성적 직송·유효기간·인정 시험 종류",
          "원서 기간·필착·검정료 해외 납부 방법",
          "종합과목·수학 코스1 등 문과 EJU 조합이 학부 지정과 맞는지",
        ],
      },
      {
        type: "h3",
        text: "다음에 할 일",
      },
      {
        type: "ul",
        items: [
          "영어 성적 가이드·요강 체크리스트로 표를 채운다",
          "관심 사립 2곳 + 국립 1곳을 비교 도구에 넣는다",
          "루트 파인더 ‘EJU → 문과’ 예시와 교차 확인",
        ],
      },
      {
        type: "note",
        text: "커뮤니티의 점수 컷 이야기는 참고만 하고, 요강 표의 과목·제출 요건을 우선하세요.",
      },
    ],
  },
  {
    id: "example-medicine-track",
    title: "예시: 의계 유학생·일반 전형 구분",
    summary:
      "도쿄대·교토대·홋대 입시 페이지에서 의계가 유학생 특별인지 일반선발인지 가르는 연습입니다.",
    category: "대학 예시",
    readTime: "6분",
    updatedAt: "2026-07",
    body: [
      {
        type: "p",
        text: "의치약은 ‘일본 대학’으로 묶여도 전형이 갈립니다. 유학생 특별전형이 없는 학부에 EJU만 준비하면 방향이 어긋납니다. 합격 가능성을 말하는 글이 아니라, 요강에서 전형을 가르는 읽기 예시입니다.",
      },
      {
        type: "h3",
        text: "시작 URL (공식)",
      },
      {
        type: "ul",
        items: [
          "도쿄대학 입시: https://www.u-tokyo.ac.jp/ja/admissions/index.html",
          "교토대학 입시: https://www.kyoto-u.ac.jp/ja/admissions",
          "홋카이도대학 입시: https://www.hokudai.ac.jp/admission/",
          "일반선발 축이면 DNC 공통테스트: https://www.dnc.ac.jp/kyotsu/",
        ],
      },
      {
        type: "h3",
        text: "가르는 질문",
      },
      {
        type: "ul",
        items: [
          "의학부(또는 치·약)에 『私費外国人留学生』 전형이 있는가?",
          "없다면 일반선발(共通テスト·본고사)만 가능한가? 출원자격은?",
          "있다면 EJU 과목·면접·서류 비중은 요강 어디에 표로 있나?",
          "영어 외부시험·일본어 요건은 필수인가?",
          "국비 이공 경로와 병행·전환이 필요하면 ‘국비→의대’ 프레임 가이드를 본다",
        ],
      },
      {
        type: "h3",
        text: "다음에 할 일",
      },
      {
        type: "ul",
        items: [
          "관심 의계 대학 2곳의 전형 유형을 비교 도구에 기록",
          "이공·의치약 분기 가이드와 체크리스트로 과목표를 채운다",
          "일반선발이면 시즌 일정의 공통테스트 블록을 연다",
        ],
      },
      {
        type: "note",
        text: "면허·임상·국가시험 안내는 학부 별도 페이지에 있을 수 있습니다. 입시 요강과 함께 확인하세요.",
      },
    ],
  },
];

export const routeOptions = {
  tracks: [
    { id: 'eju', label: 'EJU 유학생 전형' },
    { id: 'general', label: '일반입시(공통테스트·본고사)' },
    { id: 'mext', label: '국비(MEXT) 연계' },
  ],
  fields: [
    { id: 'stem', label: '이공·정보' },
    { id: 'medicine', label: '의치약·보건' },
    { id: 'humanities', label: '문과·사회' },
  ],
  stages: [
    { id: 'explore', label: '아직 탐색 중' },
    { id: 'prep', label: '본격 준비 시작' },
    { id: 'apply', label: '지원 직전' },
  ],
};

// 루트 본체는 routeProfiles.js / programExamples.js 로 이전됨.